import { ThemeConfig } from 'antd';

const theme: ThemeConfig = {
  token: {
    colorPrimary: '#47b731',
    colorText: '#35404f',
    colorTextHeading: '#35404f',
    colorWarning: '#ff6b00',
    colorSuccess: '#47B731',
    colorError: '#dc3545',
    colorBorder: '#dcdcdc',
    colorTextPlaceholder: 'rgba(53, 64, 79, 0.5)',
    controlHeight: 38,
    controlHeightSM: 31,
    borderRadius: 4,
    borderRadiusSM: 3,
    fontSizeHeading1: 20,
    lineHeightHeading1: 1.2,
    screenXXL: 1440,
    screenXXLMin: 1440,
    screenXLMax: 1439,
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#ffffff',
    },
    Badge: {
      colorError: '#A53328',
      colorErrorHover: '#A53328',
    },
    Input: {
      fontSize: 16,
      fontSizeIcon: 14,
    },
    Form: {
      paddingXS: 4,
    },
    Button: {
      controlHeightSM: 26,
    },
    Table: {
      colorFillAlter: '#FFFFFF',
      colorBgContainer: '#F3F3F3',
      controlItemBgActive: '#F3F3F3',
      controlItemBgActiveHover: '#BDE7B4',
    },
    Typography: {
      titleMarginBottom: '0.6em',
      fontWeightStrong: 700,
    },
    Menu: {
      subMenuItemBg: 'transparent',
      itemActiveBg: 'transparent',
      itemSelectedBg: '#BDE7B4',
      itemBg: 'transparent',
      lineType: 'none',
      itemBorderRadius: 100,
      subMenuItemBorderRadius: 100,
      controlHeightLG: 24,
      controlHeightSM: 24,
    },
    Popover: {
      borderRadiusLG: 12,
    },
    Modal: {
      paddingContentHorizontalLG: 16,
      titleFontSize: 20,
    },
  },
};

export default theme;
